import React, { useState, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import './legalModal.scss';
import {useSelector} from "react-redux";
import {setHeaderLoadType} from "../../slices/vehicleSlice";

function LegalModal({ client, country }) {
    const [cookies, setCookie] = useCookies();
    let [showModal, setShowModal] = useState(true);
    const { t, i18n } = useTranslation();
    const localeCountry = country === 'es'|| country === undefined ? 'us' : country;
    const cookiesName = t('cookieNamePrefix') + client + '-' + localeCountry;
    const location = useLocation();
    const headerLoadType = useSelector(setHeaderLoadType);

    useEffect(() => {
        let timeoutId;
        if (cookies[cookiesName]) {
            setShowModal(false);
            showModal = false;
        }
        if (showModal) {
            timeoutId = setTimeout(() => setShowModal(true),1000);
        }
        return () => clearTimeout(timeoutId);
    }, [i18n.language,cookies, cookiesName]);

    useEffect(() => {
        setShowModal(false);
    }, [location]);

    const handleAccept = () => {
        const expires = new Date(Date.now() + (1000 /*sec*/ * 60 /*min*/ * 60 /*hour*/ * 24 /*day*/ * 10));
        setCookie(cookiesName, true, { path: '/', expires: expires });
        setShowModal(false);
    };

    const handleLinkClick = (e) => {
        e.stopPropagation();
    };

    return (
        <>
            {showModal && headerLoadType == null && (
                <div className="legal-modal">
                    <p>{t('localizedMessage.legalModalMessage')} <a href={t('localizedMessage.disclaimerUrl')} target="_blank" onClick={handleLinkClick}>
                        {t('files.disclaimer')}</a>  {t('localizedMessage.legalMessage')}
                        <a href={t('localizedMessage.privacyUrl')} target="_blank" onClick={handleLinkClick}>{t('files.privacy')} </a></p>
                    <button onClick={handleAccept} className={'primary-btn'}>{t('buttons.legal.accept')}</button>
                </div>
            )}
        </>
    );
}

export default LegalModal;
